/**
 * Calculate the VAT price of a total price
 * @param {*} price
 * @param {*} taxRate
 * @returns
 */
export const calculateVat = (price, taxRate) => {
  return Math.round((price / (100 + taxRate)) * taxRate * 100) / 100;
};

/**
 * Convert EUR to USD using ExchangeRate API
 * @param {number} amountEur - Amount in EUR
 * @returns {Promise<{success: boolean, amountUsd: number, rate: number}>}
 */
export const convertEurToUsd = async (amountEur) => {
  if (!amountEur || amountEur <= 0) {
    return { success: true, amountUsd: 0, rate: 0 };
  }

  try {
    const apiKey = process.env.REACT_APP_EXCHANGE_RATE_API_KEY;
    const response = await fetch(`https://v6.exchangerate-api.com/v6/${apiKey}/pair/EUR/USD/${amountEur}`);
    const data = await response.json();

    if (data.result === "success") {
      return {
        success: true,
        amountUsd: Math.round(data.conversion_result * 100) / 100,
        rate: data.conversion_rate,
      };
    }

    return { success: false, amountUsd: amountEur, rate: 1 };
  } catch (error) {
    console.error("Error fetching exchange rate:", error);
    return { success: false, amountUsd: amountEur, rate: 1 };
  }
};

/**
 * Convert EUR to IDR using ExchangeRate API
 * @param {number} amountEur - Amount in EUR
 * @returns {Promise<{success: boolean, amountIdr: number, rate: number}>}
 */
export const convertEurToIdr = async (amountEur) => {
  if (!amountEur || amountEur <= 0) {
    return { success: true, amountIdr: 0, rate: 0 };
  }

  try {
    const apiKey = process.env.REACT_APP_EXCHANGE_RATE_API_KEY;
    const response = await fetch(`https://v6.exchangerate-api.com/v6/${apiKey}/pair/EUR/IDR/${amountEur}`);
    const data = await response.json();

    if (data.result === "success") {
      return {
        success: true,
        amountIdr: Math.round(data.conversion_result),
        rate: data.conversion_rate,
      };
    }

    return { success: false, amountIdr: amountEur, rate: 1 };
  } catch (error) {
    console.error("Error fetching exchange rate:", error);
    return { success: false, amountIdr: amountEur, rate: 1 };
  }
};
